import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Schaltleitung } from '../../domain/model/schaltleitung';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class SchaltleitungService {
    private http = inject(HttpClient);

    public saveSchaltleitung(schaltleitung: Schaltleitung): Observable<Schaltleitung> {
        return this.http.put(environment.API_URL + '/admin/schaltleitung/' + schaltleitung.id, schaltleitung) as Observable<Schaltleitung>;
    }

    public createSchaltleitung(schaltleitung: Schaltleitung): Observable<Schaltleitung> {
        return this.http.post(environment.API_URL + '/admin/schaltleitung', schaltleitung) as Observable<Schaltleitung>;
    }

    public deleteSchaltleitung(schaltleitung: Schaltleitung): Observable<any> {
        return this.http.delete(environment.API_URL + '/admin/schaltleitung/' + schaltleitung.id) as Observable<any>;
    }

    public getSchaltleitungen(): Observable<Schaltleitung[]> {
        return this.http.get(environment.API_URL + '/admin/schaltleitung') as Observable<Schaltleitung[]>;
    }

    public getSchaltleitung(schaltleitungId: number): Observable<Schaltleitung> {
        return this.http.get(environment.API_URL + '/admin/schaltleitung/' + schaltleitungId) as Observable<Schaltleitung>;
    }
}
